module.exports = {"path":"/404.html","body":"<h1>NOT FOUND</h1>\n<p>Nothing to see here!</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./404.md
 ** module id = 525
 ** module chunks = 0
 **/